<script>
import Kib from '@/views/koreksi/component/field/Kib.vue'
import KodeLokasi from '@/views/koreksi/component/field/KodeLokasi.vue'
import KodeBarang from '@/views/koreksi/component/field/KodeBarang.vue'
import NamaBarang from '@/views/koreksi/component/field/NamaBarang.vue'
import KodeRegisterBarang from '@/views/koreksi/component/field/KodeRegisterBarang.vue'
import NilaiPerolehan from '@/views/koreksi/component/field/NilaiPerolehan.vue'
import TanggalPerolehan from '@/views/koreksi/component/field/TanggalPerolehan.vue'
import Keberadaan from '@/views/koreksi/component/field/Keberadaan.vue'
import V2Ukuran from '@/views/koreksi/component/field/V2Ukuran.vue'
import V3NamaSpesifikasiBarang from '@/views/koreksi/component/field/V3NamaSpesifikasiBarang.vue'
import V4Alamat from '@/views/koreksi/component/field/V4Alamat.vue'
import V5GedungdanBangunanDiatasTanahMilik from '@/views/koreksi/component/field/V5GedungdanBangunanDiatasTanahMilik.vue'
import V6IndikasiTercatatGanda from '@/views/koreksi/component/field/V6IndikasiTercatatGanda.vue'
import V7IndikasiTercatatGabungan from '@/views/koreksi/component/field/V7IndikasiTercatatGabungan.vue'
import V8SkPenggunaan from '@/views/koreksi/component/field/V8SkPenggunaan.vue'
import V9Penggunaan from '@/views/koreksi/component/field/V9Penggunaan.vue'
import V11PotensiPemanfaatan from '@/views/koreksi/component/field/V11PotensiPemanfaatan.vue'
import V13PenguasaanFisik from '@/views/koreksi/component/field/V13PenguasaanFisik.vue'

export default {
  Kib,
  KodeLokasi,
  KodeBarang,
  NamaBarang,
  KodeRegisterBarang,
  NilaiPerolehan,
  TanggalPerolehan,
  Keberadaan,
  V2Ukuran,
  V3NamaSpesifikasiBarang,
  V4Alamat,
  V5GedungdanBangunanDiatasTanahMilik,
  V6IndikasiTercatatGanda,
  V7IndikasiTercatatGabungan,
  V8SkPenggunaan,
  V9Penggunaan,
  V11PotensiPemanfaatan,
  V13PenguasaanFisik,
}
</script>
